/* vue */
import Vue from 'vue';
/* vue-router */
import VueRouter from 'vue-router';
/* axios */
import axios from "axios";
/* lodash */
import lodash from "lodash";
/* moment */
import moment from "moment";
/* luxon */
import { DateTime } from "luxon";
/* router */
import clientRouter from './components/routers/clientRouters';
/* vue-google-maps */
import * as VueGoogleMaps from "vue2-google-maps";
/* v-model */
import VModal from "vue-js-modal";
/* font-awesome-icon-6 */
import { library } from '@fortawesome/fontawesome-svg-core';
import {
    faCamera, faPaste, faCloudUploadAlt, faTimes, faBold, faItalic, faStrikethrough, faParagraph,
    faUnderline, faListUl, faListOl, faBars, faExclamationCircle, faPaperclip, faExclamationTriangle,
    faCog, faPlus, faGripVertical, faCheck, faAngleDown, faWandMagicSparkles, faPhoneAlt, faLock, faLockOpen, faUnlock, faKey,
    faUser, faEllipsisV, faSortUp, faSortDown, faMapMarkedAlt, faWrench, faStar, faAt, faBookOpen, faLocationArrow,
    faFileUpload, faFileDownload, faAngleLeft, faAngleRight, faExpandAlt, faSpinner, faCaretRight, faCaretDown, faSearch,
    faExchangeAlt, faSyncAlt, faCheckCircle, faTimesCircle, faEdit, faTools, faTrash, faCircle, faChevronDown, faPrint, faDownload,
    faIndent, faOutdent, faLink, faUnlink, faAlignLeft, faAlignCenter, faAlignRight, faAlignJustify, faSuperscript, faSubscript,
    faRedoAlt, faExternalLinkAlt, faBolt, faLongArrowAltRight, faTable, faColumns,
    faShoppingBag, faCloudDownloadAlt, faSignOutAlt, faProjectDiagram, faUsers, faPlay, faMobileAlt, faUserFriends, faThLarge, faAngleDoubleLeft,
    faThumbtack, faUserCheck, faUserTimes, faPen, faUserPlus, faInfo, faDesktop, faCode, faShareAlt, 
    faCompressAlt, faLaptop, faEllipsisH, faBullseye, faScroll, faChevronRight, faInfoCircle, faMinus, 
    faPause, faForward, faFastForward, faStepForward, faRetweet, faStop, faExpand, faCompress, faMinusCircle, faTasks,
} from '@fortawesome/free-solid-svg-icons';
import {
    faSlack as fabSlack, faWhatsapp as fabWhatsapp, faDiscord as fabDiscord, faTwitter as fabTwitter,
} from '@fortawesome/free-brands-svg-icons'
import {
    faTrashAlt as farTrashAlt, faFile as farFile, faFileAlt as farFileAlt,
    faEye as farEye, faEnvelope as farEnvelope, faCalendar as farCalendar, faCommentAlt as farCommentAlt,
    faWindowMaximize as farWindowMaximize, faCheckCircle as farCheckCircle, faTimesCircle as farTimesCircle, faBell as farBell,
    faStar as farStar, faCircle as farCircle, faFileCode as farFileCode, faFilePdf as farFilePdf, faUser as farUser, faEdit as farEdit,
    faComment as farComment, faPaperPlane as farPaperPlane, faCalendarPlus as farCalendarPlus, faClipboard as farClipboard, 
    faQuestionCircle as farQuestionCircle, faPlusSquare as farPlusSquare, faPlayCircle as farPlayCircle, faClone as farClone,
    faHandPointRight as farHandPointRight,
} from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon, FontAwesomeLayers, FontAwesomeLayersText } from '@fortawesome/vue-fontawesome';
/* toasted */
import Toasted from 'vue-toasted';
/* vue-tippy */
import VueTippy, { TippyComponent } from "vue-tippy";
Vue.use(VueTippy);
Vue.component("tippy", TippyComponent);
/* vue-meta */
import VueMeta from 'vue-meta';
Vue.use(VueMeta);
/* firebase */
import firebase from "firebase/app";
import "firebase/messaging";
import "firebase/analytics";
/* scss */
import "./assets/scss/fts-style.scss";
import "./assets/scss/fts-utilities.scss";
import "./assets/scss/fts-components.scss";
import "./assets/scss/fts-theme.scss";
import "./assets/scss/fts-flags.scss";
/* css */
import 'vue-swatches/dist/vue-swatches.css';
/* google maps */
Vue.use(VueGoogleMaps, {
    load: {
        key: "AIzaSyBxXR_1K5DzIeWdi7Fc7ocbR0UVqP1P7_0",
        libraries: "places" // necessary for places input
    }
});
/* v-modal */
Vue.use(VModal, { dialog: true, dynamic: true, injectModalsContainer: true })
/* font-awesome-icon-6 */
library.add(
    faCamera, faPaste, faCloudUploadAlt, faTimes, faProjectDiagram, faUsers,
    faBars, faExclamationCircle, faPaperclip, faExclamationTriangle,
    faCog, faPlus, faGripVertical, faCheck, faAngleDown, faWandMagicSparkles, faPrint, faDownload,
    faPhoneAlt, faLock, faLockOpen, faUnlock, faKey, faUser, faEllipsisV, faSortUp, faSortDown,
    faMapMarkedAlt, faWrench, faStar, faAt, faBookOpen, faLocationArrow, faFileUpload, faFileDownload,
    faAngleLeft, faAngleRight, faExpandAlt, faSpinner, faCaretRight, faCaretDown, faSearch, faExchangeAlt, faSyncAlt,
    faCheckCircle, faTimesCircle, faEdit, faTools, faTrash, faCircle, faChevronDown,
    faRedoAlt, faExternalLinkAlt, faBolt, faLongArrowAltRight, farWindowMaximize, faTable, faColumns,
    faShoppingBag, faCloudDownloadAlt, faSignOutAlt, faPlay, faMobileAlt, faUserFriends, faThLarge, faAngleDoubleLeft,
    faThumbtack, faUserCheck, faUserTimes, faPen, faUserPlus, faInfo, faDesktop, faCode, faShareAlt,
    faCompressAlt, faLaptop, faEllipsisH, faBullseye, faScroll, faChevronRight, faInfoCircle, faMinus, 
    faPlay, faStepForward, faPause, faForward, faFastForward, faStop, faRetweet, faExpand, faCompress, faMinusCircle,
    faTasks,
)
/* brand icon */
library.add(fabWhatsapp, fabSlack, fabDiscord, fabTwitter)
/* regular icon */
library.add(
    farTrashAlt, farFile, farFileAlt, farEye, farEnvelope, farCalendar, farCommentAlt, farCheckCircle,
    farTimesCircle, farStar, farFileCode, farFilePdf, farUser, farEdit, farComment, farPaperPlane, farCalendarPlus, farClipboard, 
    farQuestionCircle, farPlusSquare, farClone, farHandPointRight
)
/* editor icon */
library.add(
    faBold, faItalic, faStrikethrough, faIndent, faOutdent, faParagraph, faUnderline, faListUl, faListOl,
    faLink, faUnlink, faAlignLeft, faAlignCenter, faAlignRight, faAlignJustify, faSuperscript, faSubscript, farBell, farCircle, 
    farPlayCircle
)

Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.component('font-awesome-layers', FontAwesomeLayers)
Vue.component('font-awesome-layers-text', FontAwesomeLayersText)
/* toasted (due to some reason so need to use window.addEventListener) */
window.addEventListener('load', () => {
    // vue toasted
    Vue.use(Toasted, {
        theme: "toasted-primary",
        position: 'top-center',
        duration: 5000,
        // iconPack: 'fontawesome',
    })
    // global success
    Vue.toasted.register('success', (payload) => {
        return payload.message || "Submission successful"
    }, { type: 'success' })
    // global error
    Vue.toasted.register('error', (payload) => {
        if (payload.response && payload.response.data && payload.response.data.message)
            return payload.response.data.message;
        else if (payload.message) 
            return payload.message;
        return "Something went wrong";
    }, { type: 'error' })
    // global invalid form validate
    Vue.toasted.register('invalidFormValidate', (payload) => {
        return payload.message || "Please ensure all values are in a proper format"
    }, { type: 'error' })
});
/* window */
window.lodash = lodash;
window.moment = moment;
window.luxon = DateTime;
window.axios = axios;
/* event bus */
window.eventBus = new Vue();
window.createBus = function () {
    //return null;
    return eventBus;
}
/* run app */
window.runClientApp = function () {
    // firebase
    var firebaseConfig = {
        apiKey: "AIzaSyBxXR_1K5DzIeWdi7Fc7ocbR0UVqP1P7_0",
        authDomain: "fetias-01.firebaseapp.com",
        databaseURL: "https://fetias-01.firebaseio.com",
        projectId: "fetias-01",
        storageBucket: "fetias-01.appspot.com",
        messagingSenderId: "664109851190",
        appId: "1:664109851190:web:7502530893af71eb382e97",
        measurementId: "G-H6XT3P234F",
    };
    firebase.initializeApp(firebaseConfig);
    firebase.analytics();
    // fcm
    try {
        let messaging = firebase.messaging();
        messaging.onMessage((payload) => {
            console.log('FCM Message received. ', payload);
            window.eventBus.$emit('notification', payload);
            // ...
        });

        messaging
            .requestPermission()
            .then(function () {
                console.log("Notification permission granted.");
                return messaging.getToken();
            })
            .then(function (token) {
                // console.log("token is : " + token);
            })
            .catch(function (err) {
                console.log("Unable to get permission to notify.", err);
            });
    } catch (ex) {
        console.warn("fcm error", ex);
    }
    // router
    const router = new VueRouter({
        routes: clientRouter,
    });
    router.beforeEach((to, from, next) => {
        if (
            to.matched.some(x => x.meta.requiresAuth) &&
            !localStorage.getItem('ls.authorizationData')
        ) {
            next({ name: 'login' });
        } else {
            next();
        }
    });
    
    const webApp = {
        template: '<router-view />'
    };

    new Vue({
        el: '#client',
        router: router,
        render: h => h(webApp),
    });
}